export default __webpack_public_path__ + "static/heroLogo-30ae855e97b2a7d6f9c3866c69498751.svg";